import classNames from "classnames"

import styles from "./index.module.scss"
import type { ImageGridItem, ImageGridRatioMode, ImageGridViewport } from "./types"

export interface ImageBlockProps {
  item: ImageGridItem
  ratioMode: ImageGridRatioMode
  viewport: ImageGridViewport
  cornerRadiusClass: string
}

const ImageBlock = ({ item, ratioMode, viewport, cornerRadiusClass }: ImageBlockProps) => {
  const alt = item.alt ?? ""
  const hasSrc = Boolean(item.src?.trim())
  const isMobile = viewport === "mobile"
  const destinationUrl = item.destinationUrl?.trim() ?? ""
  const hasLink = hasSrc && destinationUrl.length > 0
  const isFixedRatio = ratioMode === "SQUARE" || ratioMode === "PORTRAIT"

  const wrapperClass = classNames(
    styles.imageBlock,
    cornerRadiusClass,
    "box-border overflow-hidden border border-solid border-[#EBEBEB]",
    {
      [styles.imageBlockAdaptDesktop]: ratioMode === "AUTO" && !isMobile,
      [styles.imageBlockAdaptMobile]: isMobile && ratioMode === "AUTO",
      [styles.imageBlockPortrait]: ratioMode === "PORTRAIT",
      [styles.imageBlockSquare]: ratioMode === "SQUARE",
    },
  )

  const imageEl = hasSrc ? (
    <img
      alt={alt}
      className={styles.image}
      decoding="async"
      loading="lazy"
      src={item.src}
    />
  ) : (
    <div
      className={classNames(
        styles.image,
        isFixedRatio ? "h-full w-full" : "min-h-[180px] w-full",
        !isMobile && ratioMode === "AUTO" && "h-full max-h-none",
      )}
    />
  )

  return (
    <div className={classNames(wrapperClass, !hasSrc ? "bg-[#F1F1F1]" : "")}>
      {hasLink ? (
        <a
          className={styles.imageLink}
          href={destinationUrl}
          rel="noopener noreferrer"
          target="_blank"
        >
          {imageEl}
        </a>
      ) : (
        imageEl
      )}
    </div>
  )
}

export default ImageBlock
